import React, { useEffect, useState } from 'react';
import SvgCloudIcon from '../../../static/icons/svgCloudIcon';
import SvgGreenCheck from '../../../static/icons/svgGreenCheck';
import SvgAlertIcon from '../../../static/icons/svgAlertIcon';
import classNames from 'classnames';
const styles = require('./styles.pcss');

interface Props {
  onChange: Function;
  value?: File | null;
  mimeType?: string;
}

const FileUpload: React.FC<Props> = (props) => {
  const [errorMessage, setErrorMessage] = useState('');
  const [uniqueId, setUniqueId] = useState<string>('');

  useEffect(() => {
    setUniqueId(`file-upload-${Math.random().toString(36).substr(2, 9)}`);
  }, []);
  function handleFileChange(files: FileList | null) {
    if (files !== null && files.length > 0) {
      if (props.mimeType && !files[0].type.includes(props.mimeType)) {
        setErrorMessage(`You need to select a file of type ${props.mimeType}.`);
      } else {
        setErrorMessage('');
      }
      props.onChange(files);
    } else {
      setErrorMessage(`You need to select a file of type ${props.mimeType}.`);
    }

    return;
  }

  function renderFileNameLabel() {
    let errorDiv = null;
    let errorClassName = '';
    if (errorMessage.length > 0) {
      errorDiv = <div className={styles.errorMessage}>{errorMessage}</div>;
      errorClassName = styles.errorFileName;
    }

    return (
      <div className={styles.fileContainer}>
        <div className={styles.fileNameContainer}>
          <div className={styles.fileCheckIcon}>
            {errorMessage ? (
              <SvgAlertIcon
                width={24}
                height={24}
              />
            ) : (
              <SvgGreenCheck
                width={24}
                height={24}
              />
            )}
          </div>
          <div className={classNames(styles.fileName, errorClassName)}>
            {props.value?.name}
          </div>
          {errorDiv}
        </div>
        <div className={styles.changeFile}>Change File </div>
      </div>
    );
  }

  const renderContent = () => {
    if (props.value instanceof File) {
      return renderFileNameLabel();
    }

    return (
      <>
        <SvgCloudIcon
          width={32}
          height={26}
        />
        <span>Upload {props.mimeType} file</span>
      </>
    );
  };
  return (
    <>
      <label
        htmlFor={uniqueId}
        onDrop={(e) => {
          e.preventDefault();
          handleFileChange(e.dataTransfer?.files);
        }}
        onDragOver={(event) => event.preventDefault()}
      >
        <div className={styles.importEmployees}>{renderContent()}</div>
      </label>

      <input
        accept={props.mimeType}
        id={uniqueId}
        type="file"
        onChange={(e) => {
          handleFileChange(e.target.files);
        }}
        style={{ display: 'none' }}
      />
    </>
  );
};

export default FileUpload;
